// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { prepData } from 'components/PathSummary'
import { fetchProject } from 'helpers/api'
import { loadingToggler } from 'redux/modules/loading'
import { ProjectStatusIdEnum } from 'config/enums'
import getPathSettings from 'redux/modules/domain/thunks/getPathSettings'

import {
  clearProjectSummary,
  fetchAndSetProjectCompanies,
  fetchingProject,
  fetchProjectError,
  fetchProjectSuccess,
  filterAndSortPathIds,
  updateVisiblePathIds,
} from 'redux/modules/projectSummary'

const fetchAndAddProject = projectId => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { user } = getState()
      const currentUserId = user.get('userId')
      const currentUserIsDbUser = user.getIn(['permissions', 'database'])

      // clear all persisting project summary data
      dispatch(clearProjectSummary())

      await dispatch(getPathSettings())

      try {
        dispatch(fetchingProject())
        dispatch(updateVisiblePathIds())
        const d = await fetchProject(projectId)
        dispatch(fetchAndSetProjectCompanies(projectId))

        const {
          asrCheck,
          analysisStatus,
          callSignCheck,
          createUser,
          defaultCompany,
          defaultContact,
          deletedFlag,
          lastModifiedUser,
          lastModifiedTimestamp,
          projectName,
          projectStatus,
          projectType,
          unitType,
          warningsCheck,
        } = d.entity

        // if it is null, then display an error in the UI that the project's default settings
        // were not loaded correctly. This is to help identify when a DB has been updated
        // but the application was not reset.
        // This should never display in production.
        if (!unitType) {
          throw new Error('Error: This project\'s settings were not properly assigned in the database.')
        }

        const paths = prepData(d.entity.paths, unitType)

        // If the project is In Progress, then only the create user can edit.
        // if it's not In Progress, then any DB user can edit it.
        let canUserEdit = (
          projectStatus.projectStatusId === ProjectStatusIdEnum.IN_PROGRESS
            ? createUser.userId === currentUserId
            : currentUserIsDbUser
        )

        // can't nobody edit a deleted project
        if (deletedFlag) {
          canUserEdit = false
        }

        const projectSummaryMeta = {
          asrCheck,
          analysisStatus,
          callSignCheck,
          canUserEdit,
          createUser,
          defaultCompany,
          defaultContact,
          deletedFlag,
          highlightedPaths: [],
          lastModifiedUser,
          lastModifiedTimestamp,
          openPanel: '',
          paths,
          projectId: d.entity.projectId,
          projectName,
          projectStatus,
          projectType,
          unitType,
          warningsCheck,
        }

        dispatch(fetchProjectSuccess(projectSummaryMeta))
        dispatch(filterAndSortPathIds())
      } catch (err) {
        console.warn(err)
        dispatch(clearProjectSummary())
        dispatch(fetchProjectError(err.message))
      }
    })
  )
)

export default fetchAndAddProject
